"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$ = exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$outboundSchema = exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$inboundSchema = exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$ = exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$outboundSchema = exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$inboundSchema = void 0;
exports.getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurityToJSON = getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurityToJSON;
exports.getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurityFromJSON = getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurityFromJSON;
exports.getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequestToJSON = getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequestToJSON;
exports.getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequestFromJSON = getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$;
(function (GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$) {
    /** @deprecated use `GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$inboundSchema` instead. */
    GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$.inboundSchema = exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$inboundSchema;
    /** @deprecated use `GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$outboundSchema` instead. */
    GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$.outboundSchema = exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$outboundSchema;
})(GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$ || (exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$ = GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$ = {}));
function getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurityToJSON(getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity) {
    return JSON.stringify(exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$outboundSchema
        .parse(getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity));
}
function getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetSecurity' from JSON`);
}
/** @internal */
exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$inboundSchema = z.object({
    "filter[end_date]": z.string().optional(),
    "filter[start_date]": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[end_date]": "filterEndDate",
        "filter[start_date]": "filterStartDate",
    });
});
/** @internal */
exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$outboundSchema = z.object({
    filterEndDate: z.string().optional(),
    filterStartDate: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterEndDate: "filter[end_date]",
        filterStartDate: "filter[start_date]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$;
(function (GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$) {
    /** @deprecated use `GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$inboundSchema` instead. */
    GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$.inboundSchema = exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$inboundSchema;
    /** @deprecated use `GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$outboundSchema` instead. */
    GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$.outboundSchema = exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$outboundSchema;
})(GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$ || (exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$ = GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$ = {}));
function getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequestToJSON(getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest) {
    return JSON.stringify(exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$outboundSchema
        .parse(getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest));
}
function getNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetNationalPropertiesSoldStatsSalesNationalPropertiesSoldGetRequest' from JSON`);
}
//# sourceMappingURL=getnationalpropertiessoldstatssalesnationalpropertiessoldget.js.map